export const REGISTRATION_URL = "https://lynk.id/cicideveloper/82xxnxookr5n/checkout";
export const WA_URL = "https://wa.me/6287867177527";
export const IG_URL = "https://www.instagram.com/cici.developer/";
export const EVENT_DATE_ISO = "2026-11-15T10:00:00+07:00";

export const NAV_LINKS = [
    { label: "Tentang Kelas", href: "#tentang", testId: "nav-tentang" },
    { label: "Materi", href: "#materi", testId: "nav-materi" },
    { label: "Mentor", href: "#mentor", testId: "nav-mentor" },
    { label: "Benefit", href: "#benefit", testId: "nav-benefit" },
    { label: "FAQ", href: "#faq", testId: "nav-faq" },
];

export const PROBLEMS = [
    { title: "Takut Salah Pilih KPR", desc: "Belum tahu skema pembiayaan yang paling sesuai.", icon: "shield" },
    { title: "Bingung Hitung Cicilan", desc: "Sulit memahami angsuran, bunga, dan total biaya.", icon: "calculator" },
    { title: "Kaget Ada Biaya Tambahan", desc: "Belum mengenali biaya yang muncul selama proses KPR.", icon: "receipt" },
    { title: "Ingin Cepat Lunas", desc: "Belum memahami pelunasan ekstra atau dipercepat.", icon: "zap" },
    { title: "Mau Take Over KPR", desc: "Masih bingung dengan manfaat, biaya, dan prosesnya.", icon: "switch" },
];

export const AUDIENCE = [
    { title: "First-Time Homebuyer", desc: "Kamu yang sedang berencana membeli rumah pertama.", icon: "home" },
    { title: "Calon Pengaju KPR", desc: "Kamu yang ingin memahami persyaratan dan proses KPR sebelum mengajukan.", icon: "file" },
    { title: "Pemilik KPR Aktif", desc: "Kamu yang ingin belajar tentang pelunasan ekstra dan efisiensi pembiayaan.", icon: "wallet" },
    { title: "Calon Take Over KPR", desc: "Kamu yang ingin memahami pilihan serta pertimbangan sebelum melakukan take over.", icon: "refresh" },
];

export const CURRICULUM = [
    { title: "Mengenal KPR dan Jenis-Jenisnya", desc: "Kenali dasar-dasar KPR (subsidi vs komersial), berbagai jenis pembiayaan (syariah vs konvensional), serta perbedaan skema suku bunga yang ditawarkan bank." },
    { title: "Panduan KPR dari Awal hingga Approve", desc: "Hal-hal yang perlu diperhatikan selama proses pengajuan KPR agar mudah mendapatkan approval dari bank." },
    { title: "Checklist Pertanyaan sebelum Mengajukan KPR", desc: "Pertanyaan penting kepada developer dan bank yang wajib diajukan agar tidak melewatkan hal-hal yang krusial." },
    { title: "Template Hitungan Cicilan & Ebook KPR (Free senilai Rp69.000)", desc: "Hitung estimasi cicilan bulanan dan target lunas KPR-mu." },
    { title: "Transparansi Biaya KPR: Bebas Jebakan Biaya Tersembunyi", desc: "Pahami rincian biaya KPR sejak awal agar dapat mempersiapkan dan terhindar dari biaya tak terduga." },
    { title: "Checklist Dokumen yang Didapatkan saat Akad KPR", desc: "Hindari risiko di kemudian hari dengan mengetahui dokumen penting yang harus ditanyakan, diterima, dan diperiksa pada saat akad KPR." },
    { title: "Optimalisasi Strategi Pelunasan Ekstra, Pelunasan Dipercepat, serta Take Over KPR", desc: "Pelajari strategi hemat hingga ratusan juta, dengan memilih program percepatan pelunasan yang tepat. (Cocok untuk kamu yang memiliki cicilan KPR aktif)" },
];

export const BENEFITS = [
    { title: "Q&A Langsung", desc: "Q&A dan belajar langsung oleh praktisi properti.", icon: "chat" },
    { title: "Materi Eksklusif", desc: "Materi kelas eksklusif yang bisa kamu pelajari kembali.", icon: "book" },
    { title: "Konsultasi 1-on-1", desc: "Konsultasi 1-on-1 dengan Cici Developer, sesuai syarat program.", icon: "user" },
    { title: "E-Sertifikat", desc: "E-Sertifikat sebagai bukti partisipasi kelas.", icon: "award" },
];

export const FAQS = [
    { q: "Apakah kelas ini online?", a: "Ya, kelas dilaksanakan secara online melalui Zoom Meeting." },
    { q: "Apakah pemula boleh ikut?", a: "Tentu. Materi mencakup dasar-dasar KPR dan berbagai pertimbangan praktis yang relevan bagi pemula." },
    { q: "Apakah bisa bertanya langsung kepada narasumber?", a: "Ya, tersedia sesi Q&A dan pembelajaran bersama praktisi properti." },
    { q: "Apakah mendapatkan sertifikat?", a: "Ya, fasilitas kelas mencakup e-sertifikat." },
    { q: "Apakah kelas ini menjamin KPR saya disetujui?", a: "Tidak. Keputusan persetujuan KPR merupakan kewenangan bank atau lembaga pembiayaan. Kelas ini ditujukan untuk edukasi dan peningkatan pemahaman peserta." },
    { q: "Bagaimana cara mendaftar?", a: "Klik tombol pendaftaran dan ikuti petunjuk pada halaman registrasi." },
];

export const PRIZES = [
    { name: "Smartwatch", icon: "watch" },
    { name: "TWS", icon: "headphones" },
    { name: "Mini Speaker", icon: "speaker" },
];
